<template>
    <div class="mt-16">
        <ul class="flex items-center">
            <li class="flex items-center">
                <USkeleton class="h-5 w-8" />
                <UIcon name="i-heroicons:chevron-right-20-solid" class="px-2 text-gray-500 w-5 h-5 rtl:rotate-180" />
            </li>
            <li class="flex items-center">
                <USkeleton class="h-5 w-20" />
                <UIcon name="i-heroicons:chevron-right-20-solid" class="px-2 text-gray-500 w-5 h-5 rtl:rotate-180" />
            </li>
            <li class="flex items-center">
                <USkeleton class="h-5 w-20" />
                <UIcon name="i-heroicons:chevron-right-20-solid" class="px-2 text-gray-500 w-5 h-5 rtl:rotate-180" />
            </li>
            <li>
                <USkeleton class="h-5 w-20" />
            </li>
        </ul>
        <div class="flex max-md:flex-col-reverse justify-center items-center gap-8 mt-4">
            <div class="w-full md:w-1/2 flex flex-col justify-center py-4">
                <div class="bg-white/75 p-4 rounded-lg shadow-79 shadow-amazon-500/15">
                    <div class="flex justify-between items-center border-b pb-2">
                        <USkeleton class="w-1/2 h-8" />
                        <div>
                            <div class="flex items-center relative bg-gray-300 opacity-25">
                                <UiIconStar
                                    v-for="i in 5"
                                    class="relative z-20"
                                    fill="fill-white"
                                    stroke="stroke-2 stroke-gray-200"
                                />
                            </div>
                        </div>
                    </div>
                    <USkeleton class="w-1/3 h-6 mt-4" />
                </div>
                <div class="bg-white/75 p-4 rounded-lg shadow-79 shadow-amazon-500/15 mt-4">
                    <div>
                        <div v-for="i in 2" class="mt-4">
                            <USkeleton class="w-1/3 h-6" />
                            <USkeleton class="w-full h-12 mt-4" />
                        </div>
                    </div>
                    <div class="flex justify-between items-center mt-4">
                        <USkeleton class="w-1/4 h-5" />
                        <USkeleton class="w-1/3 h-10" />
                    </div>
                </div>
            </div>
            <div class="w-full md:w-1/2">
                <div class="w-full min-h-full">
                    <USkeleton class="w-full mx-auto aspect-square" />
                    <div class="flex mt-6 px-12">
                        <div v-for="i in 6" class="w-1/6 p-2">
                            <USkeleton class="w-full aspect-square" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-16 bg-white/75 p-4 rounded-lg shadow-79 shadow-amazon-500/15">
            <div class="flex justify-center gap-4">
                <USkeleton v-for="i in 3" class="w-1/6 h-8" />
            </div>
            <div class="mt-8">
                <USkeleton v-for="i in 5" class="h-4 mt-3" :style="`width: ${Math.random() * 100}%`" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup></script>

<style></style>
